<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">
              Kullanıcı Yetkileri
              <small>({{ user.name }} {{ user.surname }})</small>
            </h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <router-link tag="li" to="/" class="breadcrumb-item"
                ><a>Anasayfa</a></router-link
              >
              <router-link tag="li" to="/users" class="breadcrumb-item"
                ><a>Kullanıcılar</a></router-link
              >
              <li class="breadcrumb-item active">Kullanıcı Yetkileri</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header card-title">Site Yetki Ayarları</div>
              <div class="card-body">
                <div class="row">
                  <div class="col-12" style="margin-bottom: 20px">
                    <small class="text-danger"
                      >* Sadece yetkili olan sitelerde kullanıcı işlem yapma
                      iznine sahip olacaktır. <b> Yöneticiler </b> tüm sitelere
                      erişebilirler.
                    </small>
                  </div>

                  <div class="col" v-for="item in sites" :key="item.id">
                    <button
                      class="btn form-control"
                      :class="{
                        'btn-danger': !item.type,
                        'btn-success': item.type,
                      }"
                      @click="saveSite(item)"
                    >
                      {{ item.name }}
                      <small>({{ item.type ? "Yetkili" : "Yetkisiz" }})</small>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="card" style="min-height: 500px">
              <div class="card-header card-title">
                İşlem Yetki Ayarları
                <button
                  class="float-right btn btn-outline-danger"
                  style="margin-left: 5px"
                  @click="allDeleteModule"
                >
                  <i class="fas fa-trash"></i> Tüm Yetkileri Sil
                </button>

                <button
                  class="float-right btn btn-outline-primary"
                  @click="allAddModule"
                >
                  <i class="fas fa-plus"></i> Tüm İşlemlere Yetki Ver
                </button>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-4" style="border-right: 1px solid #eee">
                    <h1 class="card-title">
                      Departmanlar
                      <small class="text-danger"
                        >* Seçtiğiniz departmanın tüm yetkilerini ekle /
                        çıkar</small
                      >
                    </h1>
                    <br />
                    <br />
                    <ul
                      class="list-group"
                      style="
                        max-height: 430px;
                        overflow-x: hidden;
                        overflow-y: scrool;
                      "
                    >
                      <li
                        class="list-group-item"
                        v-for="item in departments"
                        :key="item.id"
                      >
                        <div class="row">
                          <div class="col">
                            <b> {{ item.name }} </b> yetkilerini
                          </div>
                          <div class="col">
                            <button
                              class="float-right btn btn-outline-danger btn-sm"
                              style="margin-left: 5px"
                              @click="allDeleteDepartmentModule(item.id)"
                            >
                              <i class="fas fa-minus"></i> Çıkar
                            </button>

                            <button
                              class="float-right btn btn-outline-primary btn-sm"
                              @click="allAddDepartmentModule(item.id)"
                            >
                              <i class="fas fa-plus"></i> Ekle
                            </button>
                          </div>
                        </div>
                      </li>

                      
                    </ul>
                  </div>
                  <div class="col-8">
                    <input
                      class="form-control"
                      v-model="search"
                      placeholder="Yetki Ara"
                    />
                    <br />
                    <ul
                      class="list-group"
                      style="
                        max-height: 420px;
                        overflow-x: hidden;
                        overflow-y: scrool;
                      "
                    >
                      <li
                        class="list-group-item"
                        v-for="item in filtered"
                        :key="item.id"
                      >
                        <div class="row">
                          <div class="col">{{ item.name }}</div>
                          <div class="col">
                            <div class="icheck-primary d-inline">
                              <input
                                type="checkbox"
                                :id="'ckr' + item.id"
                                @change="ckrChange(item)"
                                :checked="item.isRead"
                                :disabled="item.isWrite"
                              />
                              <label :for="'ckr' + item.id">
                                Görüntüleme İzni
                              </label>
                            </div>
                          </div>
                          <div class="col">
                            <div class="icheck-primary d-inline">
                              <input
                                type="checkbox"
                                :id="'ckw' + item.id"
                                @change="ckwChange(item)"
                                :checked="item.isWrite"
                              />
                              <label :for="'ckw' + item.id">
                                Değişiklik İzni
                              </label>
                            </div>
                          </div>
                        </div>
                      </li>

                      <li
                        v-if="filtered.length == 0"
                        class="list-group-item text-center"
                      >
                        Kayıt Bulunamadı
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.col-md-6 -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->
</template>
<script>
export default {
  data() {
    return {
      sites: null,
      modules: [],
      departments: [],
      search: "",
      user: {
        username: "",
        password: "",
        repassword: "",
        name: "",
        surname: "",
        isAdmin: false,
      },
    };
  },
  methods: {
    getUser() {
      this.$http
        .get("User/GetUser/" + this.$route.params.id)
        .then((response) => {
          this.user = response.data;
        });
    },
    getSites() {
      this.$http
        .get("Site/ListUserSites/" + this.$route.params.id)
        .then((response) => {
          this.sites = response.data;
        });
    },
    getModules() {
      this.$http
        .get("Module/ListUserModules/" + this.$route.params.id)
        .then((response) => {
          this.modules = response.data;
        });
    },
    getDepartments() {
      this.$http.get("department/ListDepartments/").then((response) => {
        this.departments = response.data;
      });
    },
    saveSite(item) {
      let url = "UserSite/AddUserSites";

      if (item.type) url = "UserSite/DeleteUserSites";

      url += "?user=" + this.$route.params.id + "&site=" + item.id;

      this.$http.get(url).then((response) => {
        toastr.success("Kayıt başarılı.");
        this.getSites();
      });
    },
    ckwChange(item) {
      let url = "UserModule/AddUserModules";

      if (item.isWrite) url = "UserModule/DeleteUserModules";

      this.$http
        .post(url, {
          user: this.$route.params.id,
          module: item.id,
          isRead: !item.isWrite ? true : item.isRead,
          isWrite: !item.isWrite,
        })
        .then((response) => {
          toastr.success("Kayıt başarılı.");
          this.getModules();
        });
    },
    ckrChange(item) {
      let url = "UserModule/AddUserModules";

      if (item.isRead) url = "UserModule/DeleteUserModules";

      this.$http
        .post(url, {
          user: this.$route.params.id,
          module: item.id,
          isRead: !item.isRead,
          isWrite: item.isWrite,
        })
        .then((response) => {
          toastr.success("Kayıt başarılı.");
          this.getModules();
        });
    },
    allAddModule() {
      this.$http
        .get("UserModule/AllAddUserModule/" + this.$route.params.id)
        .then((response) => {
          toastr.success("Kayıt başarılı.");
          this.getModules();
        });
    },
    allDeleteModule() {
      this.$http
        .get("UserModule/AllDeleteUserModule/" + this.$route.params.id)
        .then((response) => {
          toastr.success("Kayıt başarılı.");
          this.getModules();
        });
    },

    allAddDepartmentModule(id) {
      Swal.fire({
        title: "Önceden eklenmiş olan yetkiler silinsin mi?",
        showCancelButton: true,
        confirmButtonText: "Evet! Silinsin",
        cancelButtonText: "Hayır! Silinmesin",
        icon: "question",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.$http
            .get(
              "UserModule/AllAddDepartmentUserModule/" +
                id +
                "?user=" +
                this.$route.params.id +
                "&status=true"
            )
            .then((response) => {
              toastr.success("Kayıt başarılı.");
              this.getModules();
            });
        } else {
          this.$http
            .get(
              "UserModule/AllAddDepartmentUserModule/" +
                id +
                "?user=" +
                this.$route.params.id
            )
            .then((response) => {
              toastr.success("Kayıt başarılı.");
              this.getModules();
            });
        }
      });
    },
    allDeleteDepartmentModule(id) {
      this.$http
        .get(
          "UserModule/AllDeleteDepartmentUserModule/" +
            id +
            "?user=" +
            this.$route.params.id
        )
        .then((response) => {
          toastr.success("Kayıt başarılı.");
          this.getModules();
        });
    },
  },
  computed: {
    filtered() {
      return this.modules.filter((value) => {
        return value.name.toLowerCase().match(this.search.toLowerCase());
      });
    },
  },
  created() {
    this.getUser();
    this.getSites();
    this.getModules();
    this.getDepartments();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/User/UserAuthority.vue